export interface DougnutChartDefinition {
  data: number[];
  colors: string[];
  borders: string[];
  labels?: string[];
}

export const borderWidthOptions: { [key: string]: number } = {
  none: 0,
  default: 3,
};

export const chartDefaultBorderColor = '#ffffff';
export const chartNoValueDefaultColor = '#b5bac4';

export function getDougnutChartDefinition(
  data: { key: number; value: number; color: string; border: string; label?: string}[]
): DougnutChartDefinition {
  const initialValue: DougnutChartDefinition = {
    data: [],
    colors: [],
    borders: [],
    labels: []
  };

  return data.reduce((prev: DougnutChartDefinition, curr) => {
    return {
      data: [...prev.data, curr.value],
      colors: [...prev.colors, curr.color],
      borders: [...prev.borders, curr.border],
      labels: [...prev.labels, curr.label],
    } as DougnutChartDefinition;
  }, initialValue);
}
